export enum DayFunctionType {
  ORGANIZATIONAL_UNIT = 0,
  LABEL = 1,
}
